import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54f57f0c")

_pushScopeId("data-v-54f57f0c")
const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative" }
const _hoisted_2 = { class: "px-8 py-4 flex flex-col lg:flex-row justify-between lg:items-center gap-2 lg:gap-0" }
const _hoisted_3 = { class: "flex flex-col md:flex-row flex-wrap lg:flex-nowrap text-12px xxl:text-14px items-start lg:items-center w-full md:w-auto" }
const _hoisted_4 = { class: "font-semibold text-20px mb-2 mr-4 lg:mb-0 whitespace-nowrap text-black-lp-200 capitalize w-full lg:w-auto" }
const _hoisted_5 = { class: "bg-gray-lp-1000 pt-5 pb-10 px-8 h-full" }
const _hoisted_6 = { class: "flex flex-col h-full bg-white rounded-xl overflow-hidden" }
const _hoisted_7 = { class: "flex flex-row lg:items-center w-full md:gap-0 lg:w-auto justify-between p-4" }
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = { class: "inline-flex" }
const _hoisted_10 = {
  key: 0,
  class: "h-full justify-center py-10"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getCurrentRoute), 1)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Search, {
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              placeholder: _ctx.$t('dispatch.searchPlaceholder'),
              class: "w-60 mr-4"
            }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
            _createVNode(_component_TimeRangePicker, {
              class: "mr-4 dispatch-calendar",
              onSelect: _ctx.setPeriode,
              isCloseDateAfterSelect: "",
              default: _ctx.$t('7 hari terakhir'),
              highlightOnSelected: true,
              customCalendar: true,
              advanceStyle: {
                width: '550px',
                fontSize: 'text-sm',
                fontWeight: 'font-medium'
              },
              customTotalMaxDate: 30,
              resetLimitOnSetOption: "",
              isDateAlignCenter: "",
              maxDate: new Date(),
              isSetMaxDate: ""
            }, null, 8, ["onSelect", "default", "maxDate"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_LpButton, {
              title: _ctx.$t('dispatch.createDispatch'),
              color: "red-lp-100",
              textColor: "white",
              fontWeight: "semibold",
              onClick: _ctx.goToDispatch,
              textSize: "14",
              isWidthFull: ""
            }, null, 8, ["title", "onClick"])
          ])
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode(_component_EmptyList, {
                "button-action": _ctx.buttonActionError,
                onAction: _ctx.onRequestFetchDispatchList,
                icon: _ctx.errorData.image,
                customHeaderMessage: _ctx.errorData.title,
                customMessage: _ctx.errorData.message,
                customClassImage: "w-44"
              }, null, 8, ["button-action", "onAction", "icon", "customHeaderMessage", "customMessage"])
            ]))
          : (_openBlock(), _createBlock(_component_TableV2, {
              key: 1,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
              loading: _ctx.isLoading,
              columns: _ctx.columns,
              data: _ctx.dataTable,
              class: "my-2 rounded-xl",
              errorCause: _ctx.errorCause,
              onRequest: _ctx.onRequestFetchDispatchList,
              borderTop: false,
              totalColumnFreeze: 0,
              pinnedSubstractHeight: "280px",
              paginationStyle: "v3",
              bgHeader: "bg-white",
              isBorderOnHeadBgWhite: "",
              isNoPaddingBottom: "",
              customClassPagination: "w-full h-full flex items-end px-3",
              isSpaceTop: false,
              paginationV3PaddingVertical: "pb-4 pt-5",
              compactDesign: "",
              isDetailAble: _ctx.isDetailAble,
              onClick: _ctx.goToDetail
            }, null, 8, ["pagination", "loading", "columns", "data", "errorCause", "onRequest", "isDetailAble", "onClick"]))
      ])
    ])
  ]))
})